const { SETTINGS_DATA_SOURCE_TYPES_ARRAY } = require("@infinode/components/settings/constants");

const TOTAL_POINTS_NUM = 100;

const doesDataHaveValue = dataItem => SETTINGS_DATA_SOURCE_TYPES_ARRAY.find(t => dataItem.get(t) !== 0) !== undefined;

const filterData = dataList => {
  const count = dataList.size;
  const gap = Math.floor(count / TOTAL_POINTS_NUM);
  // const firstNonZeroIndex = dataList.findIndex(d => doesDataHaveValue(d));
  // const lastNonZeroIndex = dataList.findLastIndex(d => doesDataHaveValue(d));
  // return dataList.filter((d, index) => index <= firstNonZeroIndex || index >= lastNonZeroIndex || index % gap === 0);
  return dataList.filter((d, index) => index % gap === 0);
};

export { filterData };
